import { Link } from 'react-router-dom';
import { genres } from '@/mocks/genres';

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="w-full px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg text-background-50">
                <i className="ri-clapperboard-line" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">草民电影</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              专注影视内容分享与资讯更新，为影迷提供最新电影动态、精选影片推荐与详尽的影片资料。
            </p>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-background-50">内容导航</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li>
                <Link to="/" className="transition-colors hover:text-accent-400">首页</Link>
              </li>
              <li>
                <Link to="/news" className="transition-colors hover:text-accent-400">电影资讯</Link>
              </li>
              <li>
                <Link to="/movies/popular" className="transition-colors hover:text-accent-400">热门电影</Link>
              </li>
              <li>
                <Link to="/search" className="transition-colors hover:text-accent-400">影片搜索</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-background-50">电影类型</h4>
            <ul className="grid grid-cols-2 gap-2.5 text-sm text-background-300">
              {genres.slice(0, 6).map((genre) => (
                <li key={genre.key}>
                  <Link
                    to={`/movies/category/${genre.key}`}
                    className="transition-colors hover:text-accent-400"
                  >
                    {genre.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-semibold text-background-50">关于与联系</h4>
            <ul className="space-y-2.5 text-sm text-background-300">
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-400">关于我们</Link>
              </li>
              <li>
                <Link to="/contact" className="transition-colors hover:text-accent-400">联系我们</Link>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-accent-400" /> hello@caominmovie.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-base text-accent-400" /> 400-800-2025
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-700">
        <div className="flex w-full flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-400 md:flex-row md:px-6">
          <p>© 2025 草民电影 · 本站内容为演示性质，不提供任何影片播放与下载服务。</p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-accent-400">版权声明</Link>
            <Link to="/contact" className="transition-colors hover:text-accent-400">意见反馈</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}